import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';

import { imgPath } from '~src/common/utilities/ImgUrl';
import { FeatureFlags } from '~src/ts/FeatureFlags';

export interface RemoteAgentStateTextStrings {
  stateTextConnected: string;
  stateTextNotConnected: string;
  stateTextNotInServiceMode: string;
  stateTextNotResponsive: string;
  stateTextNeedsUpgrade: string;
  stateTextThrottled: string;
}

export type RemoteAgentPresenceIconProps = Readonly<{
  currentState: string;
  currentStateString: string;
  stateTextStrings: RemoteAgentStateTextStrings;
}>;

export function RemoteAgentPresenceIcon(props: RemoteAgentPresenceIconProps) {
  if (FeatureFlags.edgeMultiPoolEnabled) {
    return <img
      className={statusIconClass}
      title={getStateText(props)}
      src={imgPath(getStateImage(props))}
      alt={''}
    />;
  }

  return <span className={getClassNames(props)} title={getStateText(props)} />;
}

function getClassNames(props: RemoteAgentPresenceIconProps) {
  switch (props.currentState) {
    case 'CONNECTED':
      return 'tb-remote-agent-presence-icon tb-remote-agent-presence-connected';

    case 'THROTTLED':
      return 'tb-remote-agent-presence-icon tb-remote-agent-presence-warning';

    case 'DISCONNECTED':
    case 'NOT_IN_SERVICE_MODE':
    case 'NOT_RESPONSIVE':
    case 'NEEDS_UPGRADE':
      return 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected';

    // The default style takes up the same amount of space but otherwise does not appear
    default:
      return 'tb-remote-agent-presence-icon';
  }
}

// TODO - ndepass 9/15/21 - Story 1297102: [BridgeSiteSettings] Create Multi-Pool table
// fix implicit dependency - state, text and image
function getStateText(props: RemoteAgentPresenceIconProps) {
  switch (props.currentState) {
    case 'CONNECTED': return props.stateTextStrings.stateTextConnected;
    case 'NOT_RESPONSIVE': return props.stateTextStrings.stateTextNotResponsive;
    case 'NEEDS_UPGRADE': return props.stateTextStrings.stateTextNeedsUpgrade;
    case 'THROTTLED': return props.stateTextStrings.stateTextThrottled;
    case 'DISCONNECTED': return props.stateTextStrings.stateTextNotConnected;
    case 'NOT_IN_SERVICE_MODE': return props.stateTextStrings.stateTextNotInServiceMode;
    default: return null;
  }
}

function getStateImage(props: RemoteAgentPresenceIconProps) {
  switch (props.currentState) {
    case 'CONNECTED':
      return 'status_active_18px-large.svg';
    case 'DISCONNECTED':
    case 'NOT_IN_SERVICE_MODE':
    case 'NOT_RESPONSIVE':
      return 'status_down_18px-large.svg';
    case 'THROTTLED':
    case 'NEEDS_UPGRADE':
      return 'status_error_18px-large.svg';
    default:
      return '';
  }
}

export const statusIconClass = style({
  verticalAlign: 'text-bottom',
  marginRight: TabStyles.Spacing.DefaultSpace
});
